// Module
var code = "<bringoz-button class=\"show-button\" type=\"tertiary\" (on-click)=\"$ctrl.onShowPanel($event)\"> <bringoz-icon icon-name=\"settings\"></bringoz-icon> </bringoz-button> ";
// Exports
export default code;